import React from "react";
import { Link } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import { Helmet } from "react-helmet";

export default function Blogs() {
  return (
    <>
      {/* SEO Metadata */}
      <Helmet>
        <title>Blogs | HealthTech Solutions</title>
        <meta
          name="description"
          content="Read expert blogs on artificial intelligence, digital marketing, SEO strategies, website development and emerging technology trends to help businesses grow online."
        />
        <meta
          name="keywords"
          content="AI solutions company, digital marketing agency, SEO services, website development company, software development company, IT consulting services, AI technology solutions"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.healthtechsl.com/blogs" />

        {/* Open Graph Tags */}
        <meta
          property="og:title"
          content="Technology & Digital Marketing Blogs"
        />
        <meta
          property="og:description"
          content="Latest insights on AI, SEO, website development and digital marketing strategies."
        />
        <meta
          property="og:image"
          content="https://healthtechsl.com/images/blog-banner.jpg"
        />
        <meta property="og:url" content="https://healthtechsl.com/blogs" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Technology & Digital Marketing Blogs"
        />
        <meta
          name="twitter:description"
          content="Latest insights on AI, SEO, website development and digital marketing strategies."
        />
        <meta
          name="twitter:image"
          content="https://healthtechsl.com/images/blog-banner.jpg"
        />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Blog",
            "name": "Healthtech Solutions Blog",
            "url": "https://healthtechsl.com/blogs",
            "description": "Insights on digital marketing, AI technology, SEO and software development."
          }
          `}
        </script>

        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Healthtech Solutions Pvt Ltd",
            "url": "https://healthtechsl.com",
            "logo": "https://healthtechsl.com/images/logo.png"
          }
          `}
        </script>
        {/* Google Analytics */}
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-DE4KQ9E1T2"
        ></script>

        <script
          dangerouslySetInnerHTML={{
            __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'G-DE4KQ9E1T2');
            `,
          }}
        />
        {/* Google Tag Manager */}
        <script
          dangerouslySetInnerHTML={{
            __html: `
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-NJ6DNHM7');
            `,
          }}
        />
        {/* Google Tag Manager (noscript) */}
        <noscript
          dangerouslySetInnerHTML={{
            __html: `
      <iframe 
        src="https://www.googletagmanager.com/ns.html?id=GTM-NJ6DNHM7"
        height="0"
        width="0"
        style="display:none;visibility:hidden">
      </iframe>
    `,
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: [
                {
                  "@type": "Question",
                  name: "What topics are covered in your blogs?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Our blogs cover AI, digital marketing, SEO strategies, website development, and emerging technology trends.",
                  },
                },
                {
                  "@type": "Question",
                  name: "How often do you publish blogs?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "We regularly publish blogs to provide the latest insights and updates in technology and digital marketing.",
                  },
                },
              ],
            }),
          }}
        />
      </Helmet>
      <Breadcrumb title="Blogs" />

      <div className="latest-news our-blog">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="blog-item wow fadeInUp" data-wow-delay="0.25s">
                <div className="post-featured-image">
                  <figure className="image-anime">
                    <Link to="#">
                      <img src="/assets/images/ai.png" alt="" />
                    </Link>
                  </figure>
                </div>

                <div className="post-item-body">
                  <p>
                    <Link to="/ai-transforming-pharmaceutical-industry-2026">
                      09 March 2026
                    </Link>
                  </p>
                  <h2>
                    <Link to="/ai-transforming-pharmaceutical-industry-2026">
                      How AI is Transforming the Pharmaceutical Industry in 2026
                    </Link>
                  </h2>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="blog-item wow fadeInUp" data-wow-delay="0.5s">
                <div className="post-featured-image">
                  <figure className="image-anime">
                    <Link to="#">
                      <img src="/assets/images/4.png" alt="" />
                    </Link>
                  </figure>
                </div>

                <div className="post-item-body">
                  <p>
                    <Link to="/digital-transformation-pharma-pharma-companies-need-ai-solutions-today">
                      07 March 2026
                    </Link>
                  </p>
                  <h2>
                    <Link to="/digital-transformation-pharma-pharma-companies-need-ai-solutions-today">
                      Digital Transformation in Pharma: Why Pharma Companies
                      Need AI & IT Solutions Today
                    </Link>
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="blog-item wow fadeInUp" data-wow-delay="0.5s">
                <div className="post-featured-image">
                  <figure className="image-anime">
                    <Link to="#">
                      <img src="/assets/images/top-digital.png" alt="" />
                    </Link>
                  </figure>
                </div>

                <div className="post-item-body">
                  <p>
                    <Link to="/top-digital-solutions-every-pharmaceutical-company-implement-2026">
                      07 March 2026
                    </Link>
                  </p>
                  <h2>
                    <Link to="/top-digital-solutions-every-pharmaceutical-company-implement-2026">
                      Top Digital Solutions Every Pharmaceutical Company Should
                      Implement in 2026
                    </Link>
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="blog-item wow fadeInUp" data-wow-delay="0.5s">
                <div className="post-featured-image">
                  <figure className="image-anime">
                    <Link to="#">
                      <img src="/assets/images/How data Analytics.png" alt="" />
                    </Link>
                  </figure>
                </div>

                <div className="post-item-body">
                  <p>
                    <Link to="/data-analytics-revolutionizing-pharmaceutical-business-growth">
                      07 March 2026
                    </Link>
                  </p>
                  <h2>
                    <Link to="/data-analytics-revolutionizing-pharmaceutical-business-growth">
                      How Data Analytics is Revolutionizing Pharmaceutical
                      Business Growth
                    </Link>
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="blog-item wow fadeInUp" data-wow-delay="0.5s">
                <div className="post-featured-image">
                  <figure className="image-anime">
                    <Link to="#">
                      <img src="/assets/images/pharma It service.png" alt="" />
                    </Link>
                  </figure>
                </div>

                <div className="post-item-body">
                  <p>
                    <Link to="/pharma-services-india-future-ai-powered-healthcare-technology">
                      07 March 2026
                    </Link>
                  </p>
                  <h2>
                    <Link to="/pharma-services-india-future-ai-powered-healthcare-technology">
                      Pharma IT Services in India: The Future of AI-Powered
                      Healthcare Technology
                    </Link>
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="blog-item wow fadeInUp" data-wow-delay="0.5s">
                <div className="post-featured-image">
                  <figure className="image-anime">
                    <Link to="#">
                      <img src="/assets/images/1200x805.png" alt="" />
                    </Link>
                  </figure>
                </div>

                <div className="post-item-body">
                  <p>
                    <Link to="/artificial-intelligence-transforming-digital-marketing">
                      28 March 2026
                    </Link>
                  </p>
                  <h2>
                    <Link to="/artificial-intelligence-transforming-digital-marketing">
                      How Artificial Intelligence is Transforming Digital
                      Marketing
                    </Link>
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="blog-item wow fadeInUp" data-wow-delay="0.5s">
                <div className="post-featured-image">
                  <figure className="image-anime">
                    <Link to="#">
                      <img src="/assets/images/website_traffic.png" alt="" />
                    </Link>
                  </figure>
                </div>

                <div className="post-item-body">
                  <p>
                    <Link to="/what-are-the-best-seo-strategies-to-increase-website-traffic-in-2025">
                      14 April 2026
                    </Link>
                  </p>
                  <h2>
                    <Link to="/what-are-the-best-seo-strategies-to-increase-website-traffic-in-2025">
                      What are the best SEO strategies to increase website
                      traffic in 2025?
                    </Link>
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="blog-item wow fadeInUp" data-wow-delay="0.5s">
                <div className="post-featured-image">
                  <figure className="image-anime">
                    <Link to="#">
                      <img src="/assets/images/strategy.png" alt="" />
                    </Link>
                  </figure>
                </div>

                <div className="post-item-body">
                  <p>
                    <Link to="/every-business-needs-professional-website-development-strategy">
                      20 April 2026
                    </Link>
                  </p>
                  <h2>
                    <Link to="/every-business-needs-professional-website-development-strategy">
                      Why Every Business Needs a Professional Website
                      Development Strategy
                    </Link>
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="blog-item wow fadeInUp" data-wow-delay="0.5s">
                <div className="post-featured-image">
                  <figure className="image-anime">
                    <Link to="#">
                      <img src="/assets/images/seolead.png" alt="" />
                    </Link>
                  </figure>
                </div>

                <div className="post-item-body">
                  <p>
                    <Link to="/how-seo-services-help-businesses-generate-high-quality-leads">
                      23 April 2026
                    </Link>
                  </p>
                  <h2>
                    <Link to="/how-seo-services-help-businesses-generate-high-quality-leads">
                      How SEO Services Help Businesses Generate High-Quality
                      Leads
                    </Link>
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="blog-item wow fadeInUp" data-wow-delay="0.5s">
                <div className="post-featured-image">
                  <figure className="image-anime">
                    <Link to="#">
                      <img src="/assets/images/blog-5.png" alt="" />
                    </Link>
                  </figure>
                </div>

                <div className="post-item-body">
                  <p>
                    <Link to="/website-development-trends-every-business-should-know">
                      25 April 2026
                    </Link>
                  </p>
                  <h2>
                    <Link to="/website-development-trends-every-business-should-know">
                     Website Development Trends Every Business Should Know 
                    </Link>
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="blog-item wow fadeInUp" data-wow-delay="0.5s">
                <div className="post-featured-image">
                  <figure className="image-anime">
                    <Link to="#">
                      <img src="/assets/images/ai-traditional.png" alt="" />
                    </Link>
                  </figure>
                </div>

                <div className="post-item-body">
                  <p>
                    <Link to="/ai-vs-traditional-digital-marketing-works-best-2026">
                      28 April 2026
                    </Link>
                  </p>
                  <h2>
                    <Link to="/ai-vs-traditional-digital-marketing-works-best-2026">
                    AI vs Traditional Digital Marketing: What Works Best in 2026? 
                    </Link>
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
